import React from "react";
import { safeJSONParse } from "../../../utils/helper";
import EvaluationCard from "../../EvaluationCard";
import styles from "../agent-response.module.scss";

type PressReleaseAgentProps = {
  parsedContent: any;
  handleSuggestionClick: (suggestion: string) => void;
};

export default function PressReleaseAgent({
  parsedContent,
  handleSuggestionClick,
}: PressReleaseAgentProps): JSX.Element {
  const finalAnswer = safeJSONParse(parsedContent?.finalAnswer);
  const brandAnswer = safeJSONParse(parsedContent?.brandReviewerAnswer);

  const actionableFixes =
    (Array.isArray(brandAnswer?.payload?.actionable_fixes) &&
      brandAnswer?.payload?.actionable_fixes) ||
    [];

  return (
    <div>
      {/* PRESS RELEASE UI */}
      <div className={styles.postHeader}>
        <h3>{finalAnswer?.payload?.headline}</h3>
        <h4>{finalAnswer?.payload?.subheadline}</h4>
        <p>{finalAnswer?.payload?.date}</p>
      </div>

      <div className={styles.pressReleaseContent}>
        {(finalAnswer?.payload?.body || []).map(
          (body: string, idx: number) => (
            <p key={idx}>{body}</p>
          )
        )}
      </div>

      <div className={styles.postHeader}>
        <h4>{finalAnswer?.payload?.boiler_plate?.title || ""}</h4>
        <p>{finalAnswer?.payload?.boiler_plate?.body || ""}</p>
      </div>

      <div className={styles.mediacontact}>
        {finalAnswer?.payload?.media_contact}
      </div>
      <h3 className={styles.brandName}>
        Brand tone adherence review for the above drafted Press Release
      </h3>
      {/* BRAND REVIEWER UI */}
      {brandAnswer?.payload?.pillars?.length > 0 &&
        brandAnswer.payload?.pillars?.map((pillar: any, idx: number) => {
          const totalCount = pillar.dos.length + pillar.donts.length;
          return (
            <EvaluationCard
              key={idx}
              sectionKey={pillar.pillar_id}
              sectionTitle={pillar.pillar_name}
              score={pillar.pillar_score}
              total={totalCount}
              scroreLevel="low"
              sections={[
                {
                  key: "dos",
                  title: "Do's Evaluation",
                  criteria: pillar.dos.map((rule: any) => ({
                    label: rule.rule_id,
                    score: rule.value,
                  })),
                },
                {
                  key: "donts",
                  title: "Don'ts Evaluation",
                  criteria: pillar.donts.map((rule: any) => ({
                    label: rule.rule_id,
                    score: rule.value,
                  })),
                },
              ]}
            />
          );
        })}

      {finalAnswer?.payload?.suggestions &&
        finalAnswer?.payload?.suggestions?.length > 0 && (
          <div className={styles.suggestionsContainer}>
            {finalAnswer?.payload?.suggestions?.map(
              (suggestion: string, idx: number) => (
                <div
                  className={styles.suggestionBox}
                  key={idx}
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  <p>{suggestion}</p>
                </div>
              )
            )}
          </div>
        )}

      <div className={styles.finalQuestion}>
        <div className={styles.feedbackForm}>
          <h3>
            Do you have any feedback for the draft above? I can enrich it if
            you provide more information. You can share details such as:
          </h3>
          <ul>
            <li>
              How this announcement aligns to strategic initiatives and/or
              previous announcements
            </li>
            <li>
              Which global trends affect or are affected by this announcement
            </li>
            <li>Any concrete data or metrics related to the announcement</li>
          </ul>
          <p>
            Alternately, if the draft looks good, would you like me to
            translate it into Arabic now?
          </p>
        </div>
      </div>
    </div>
  );
}
